import { StyleSheet } from 'react-native'
import { Theme } from '@theme'

export const getMenuStyles = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: 'white',
    },
    scrollView: {
      flex: 1,
    },
    menuContainer: {
      paddingTop: 10,
    },
    logoutButton: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 16,
      paddingHorizontal: 20,
      backgroundColor: 'white',
    },
    iconContainer: {
      width: 15,
      alignItems: 'flex-start',
      marginRight: 10,
    },
    logoutText: {
      fontSize: 13,
      color: '#2c2c2c',
      fontWeight: '400',
      flex: 1,
    },
    versionText: {
      textAlign: 'right',
      color: '#999',
      paddingBottom: 16,
      paddingHorizontal: 20,
    },
  })

// Legacy styles - to be removed after migration
export default (theme: Theme, top: number) =>
  StyleSheet.create({
    header: {
      width: '100%',
      paddingTop: top + theme.spacing.xl,
      backgroundColor: theme.colors.primary,
      alignItems: 'center',
    },
    image: {
      width: 100,
      height: 100,
      borderRadius: 50,
      borderWidth: 4,
      borderColor: theme.colors.white,
    },
    buttonProfileContainer: {
      paddingTop: theme.spacing.md,
      paddingBottom: theme.spacing.lg,
    },
    buttonProfile: {
      paddingHorizontal: theme.spacing.xxxl + theme.spacing.sm,
      paddingVertical: theme.spacing.sm,
    },
    name: {
      paddingVertical: theme.spacing.sm,
    },
    optionsContainer: {
      flex: 1,
      justifyContent: 'space-between',
      paddingVertical: theme.spacing.xxxl,
      paddingHorizontal: theme.spacing.xl,
    },
    rowContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingBottom: theme.spacing.lg,
    },
    icon: {
      paddingRight: theme.spacing.sm,
    },
  })
